import {useTolgee} from "@tolgee/react";
import {memo} from "react";
import {convertFromTolgeeLanguageCode} from ".";
import {GIBBERISH_DATE, DateInput, parseDate} from "./dateUtils";

type FormattedDateProps = {date: DateInput | null | undefined} & Intl.DateTimeFormatOptions;

const FormattedDate = memo(({date, ...options}: FormattedDateProps) => {
  const tolgee = useTolgee(["language"]);
  const currentLanguage = tolgee.getLanguage();

  const parsed = parseDate(date);
  if (!parsed) return null;

  if (currentLanguage === "xx") {
    return <>{GIBBERISH_DATE}</>;
  }

  const locale = currentLanguage ? convertFromTolgeeLanguageCode(currentLanguage) : undefined;
  const formatted = new Intl.DateTimeFormat(locale, options).format(parsed);
  return <>{formatted}</>;
});

export default FormattedDate;
